import React from 'react';

export const FacebookIcon = (props) => {
  return (
    <svg viewBox='0 0 24 24' fill='currentColor' height='1em' width='1em' {...props}>
      <path d='M20 3H4a1 1 0 00-1 1v16a1 1 0 001 1h8.615v-6.96h-2.338v-2.725h2.338v-2c0-2.325 1.42-3.592 3.5-3.592.699-.002 1.399.034 2.095.107v2.42h-1.435c-1.128 0-1.348.538-1.348 1.325v1.735h2.697l-.35 2.725h-2.348V21H20a1 1 0 001-1V4a1 1 0 00-1-1z' />
    </svg>
  );
};
